import MetricCard from './metric'
import ServiceCard from './service'
import ListCard from './list'

const Cards = {}

Cards.Metric = MetricCard
Cards.Service = ServiceCard
Cards.List = ListCard

export default Cards
